import { $Resources } from '@cwd/lib/main';
import { api } from '@cwd/lib/main';
import type { Form, FormIssue } from './FormEditor.types';

const issueListingOdata =
    '$expand=Category,LastModifiedBy,Tags,AccessControlList,Event,Survey&$select=IssueId,Status,Subject,IssueName,Category,Tags,AccessControlList,LastModified,LastModifiedBy,StartedDateTime,UseIssueVariationTest,Event/EventId,Event/Name,Event/Start,Event/ParticipantStatusChangeIssueId,Survey/SurveyId,Survey/Title';

export async function loadIssuesForDoubleOptIn(): Promise<FormIssue[]> {
    return api.get('/Issues/ForDoubleOptIn?' + issueListingOdata);
}

export async function loadIssuesForTransactional(): Promise<FormIssue[]> {
    return api.get('/Issues/ForTransactional?' + issueListingOdata);
}

export async function loadForm(ms: number, formData?: Form): Promise<Form> {
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve(formData || getDefaultFormData());
        }, ms);
    });
}

const getDefaultFormData = (): Form => {
    return {
        title: $Resources.NewFormContentTitle,
        introduction: $Resources.NewFormContentIntroduction,
        consent: $Resources.NewFormContentConsent,
        button: $Resources.NewFormContentButton,
        image: {
            src: '',
            alt: '',
        },
        cssVars: {
            FrameWidth: '480px',
            FrameBackgroundColor: '#ffffff',
            FramePaddingTop: '30px',
            FramePaddingRight: '30px',
            FramePaddingBottom: '30px',
            FramePaddingLeft: '30px',
            FrameRadius: '6px',
            FrameBorderWidth: '1px',
            FrameBorderColor: '#dddddd',
            ButtonPaddingTop: '15px',
            ButtonBackgroundColor: '#1fa9b0',
            ButtonBackgroundColorHover: '#1fa9b0',
            ButtonPaddingBottom: '15px',
            ButtonPaddingLeft: '25px',
            ButtonPaddingRight: '25px',
            ButtonRadius: '4px',
            ButtonBorderWidth: '1px',
            ButtonBorderColor: '#1fa9b0',
            ButtonFontFamily: "'Open Sans'",
            ButtonFontSize: '16px',
            ButtonLineHeight: '125%',
            ButtonColor: '#ffffff',
            ButtonColorHover: '#ffffff',
            ButtonFontWeight: '700',
            ButtonJustifyContent: 'end',
            ButtonWidth: 'auto',
            ImageFlexDirection: 'row-reverse',
            ImageWidth: '40%',
            HeadingFontFamily: "'Open Sans'",
            HeadingFontSize: '30px',
            HeadingLineHeight: '125%',
            HeadingColor: '#1f1c26',
            InputsBackgroundColor: '#eeeeee',
            HeadingFontWeight: '700',
            TextFontFamily: "'Open Sans'",
            TextFontSize: '16px',
            TextLineHeight: '150%',
            TextColor: '#1f1c26',
            TextFontWeight: '400',
            LabelsFontFamily: "'Open Sans'",
            LabelsFontSize: '14px',
            LabelsLineHeight: '125%',
            LabelsColor: '#1f1c26',
            LabelsFontWeight: '400',
            InputsPaddingTop: '10px',
            InputsPaddingBottom: '10px',
            InputsPaddingRight: '15px',
            InputsPaddingLeft: '15px',
            InputsBorderTopWidth: '1px',
            InputsBorderRightWidth: '1px',
            InputsBorderLeftWidth: '1px',
            InputsBorderBottomWidth: '1px',
            InputsRadius: '4px',
            InputsBorderColor: '#cccccc',
            InputsFontFamily: "'Open Sans'",
            InputsFontSize: '16px',
            InputsLineHeight: '125%',
            InputsColor: '#1f1c26',
        },
        googleFonts: 'Open+Sans:700,regular',
        listsDisplay: 'hidden',
        lists: [],
        formFields: [
            {
                contactField: 'Name',
                type: 'text',
                label: $Resources.NewFormContentNameLabel,
                description: '',
                required: false,
                placeholder: $Resources.NewFormContentNamePlaceholder,
            },
            {
                contactField: 'Email',
                type: 'email',
                label: $Resources.NewFormContentEmailLabel,
                description: '',
                required: true,
                placeholder: $Resources.NewFormContentEmailPlaceholder,
            },
        ],
        confirmationIssueId: '',
        doubleOptInIssueId: '',
        doubleOptInUrl: '',
        subscriptionConfirmedUrl: '',
        subscriptionFailedUrl: '',
        defaultCountryCode: $Resources.NewFormContentCountryCode,
        sourceName: '',
    };
};
